import firebase from 'firebase/app';
import 'firebase/database';
import { baseApiUrl } from "../environment/values";
import { axiosInstance as axios } from '../main';
import router from '../router';

const STATUS = {
  FAIL: 'fail',
  SUCCES: 'success',
  PENDING: 'pending'
}

const getDefaultState = () => {
  return {
    authorized: false,
    accessWithAutologin: false,
    autologinStatus: undefined
  }
}

const state = {
  authorized: false,
  accessWithAutologin: false,
  autologinStatus: undefined
}
const getters = {
  signWithLink: state => {
    return state.accessWithAutologin || JSON.parse(localStorage.getItem('accessWithAutologin') || 'false')
  }
}
const actions = {
  async login({ dispatch }, { email, password }) {
    try {
      const { user } = await firebase.auth().signInWithEmailAndPassword(email, password)

      if (user) {
        await dispatch('saveUserData', user)
      }
    } catch (error) {
      throw error
    }
  },
  async loginWithGoogle({ dispatch }, { provider }) {
    try {
      await firebase.auth().signOut()
      const { user } = await firebase.auth().signInWithPopup(provider)
      if (user) {
        await dispatch('saveUserData', user)
      }
    } catch (error) {
      console.log(error)
    }
  },
  async autologin({ commit, dispatch }, keyParam) {
    commit('setAutologinStatus', STATUS.PENDING)
    commit('setAccessWithAutologin', true)

    try {
      const urlParams = new URLSearchParams(keyParam);

      if (urlParams.has("key")) {
        const keyValue = urlParams.get("key");
        const urlAutologin = `${baseApiUrl}autologin/`
        let userInfo = null

        try {
          const { data } = await axios.post(urlAutologin, {
            key: keyValue,
          });
          userInfo = data
        } catch (error) {
          console.error({ error })
          throw error
        }

        const { firebase_custom_token, request_id } = userInfo || {}

        if (firebase_custom_token) {
          try {
            const { user } = await firebase.auth().signInWithCustomToken(firebase_custom_token)
            if (user) {
              commit('setAutologinStatus', STATUS.SUCCES)
              user.requestId = request_id
              await dispatch('saveUserData', user)
            }
          } catch (error) {
            commit('setAutologinStatus', STATUS.FAIL)
            throw new Error('Error al loguearse con custom token')
          }
        }
      }
    } catch (error) {
      router.push({ name: 'login' })
      throw error
    }
  },
  async getUserSettings({ getters, rootState }, user) {
    const { uid: userId, requestId } = user

    var appSettings = firebase.database().ref(userId + "/settings");

    await appSettings.once("value").then((snapshot) => {
      const userSettings = snapshot.val();
      localStorage.setItem("baseURL", JSON.stringify(baseApiUrl));
      localStorage.setItem("userSettings", JSON.stringify(userSettings));

      if (getters.signWithLink && requestId) {
        router.push({ name: 'request-detail', params: { id: requestId } })
        return
      }

      if (rootState.mobsUser) {
        router.push({ name: 'visit-list' });
      } else {
        router.push({ name: "visit-list" });
      }
    });
  },
  async saveUserData({ commit, dispatch }, user) {
    let currentTime = new Date();
    currentTime = currentTime.getTime();
    localStorage.setItem("lastTokenRefreshTime", currentTime);
    commit("setAuthorized", true);
    localStorage.setItem("user", JSON.stringify(user));
    await dispatch('getUserSettings', user)
  }
}
const mutations = {
  setAuthorized: (state, payload) => (state.authorized = payload),
  setAccessWithAutologin: (state, payload) => {
    state.accessWithAutologin = payload
    localStorage.setItem('accessWithAutologin', payload)
  },
  setAutologinStatus: (state, payload) => (state.autologinStatus = payload),
  setState: (state) => {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
